import { FIELD_TYPE, FORMAT_TIME } from "types/enums";
import { DataFormField } from "types/models/input-field-type";
const { INPUT, SELECT, DATE, TEXT_AREA } = FIELD_TYPE;
const fields: DataFormField[] = [
  {
    type: DATE,
    label: "Ngày tạo",
    name: "ngayKham",
    optionsTime: { format: FORMAT_TIME.dateTime, showTime: true },
    disable: true,
  },
  {
    type: INPUT,
    label: "Số điện thoại",
    name: "soDienThoai",
    disable: true,
  },

  {
    type: INPUT,
    label: "Thân nhân",
    name: "thanNhan",
    disable: true,
  },
  {
    type: INPUT,
    label: "Bác sĩ chỉ định",
    name: "bacSyChiDinh",
    disable: true,
  },
  {
    type: INPUT,
    label: "Địa chỉ",
    disable: true,
    name: "diaChi",
  },
  {
    type: TEXT_AREA,
    label: "Chỉ định",
    disable: true,
    name: "dichVu",
  },
  {
    type: DATE,
    label: "TG chỉ định",
    name: "ngayChiDinh",
    optionsTime: { format: FORMAT_TIME.dateTime, showTime: true },
  },
];
export { fields };
